export enum EvaluationResponseStatus {
  inProgress = 0,
  completed = 1,
  abandoned = 2,
  notStarted = 3,
}

export const isFinished = (status?: EvaluationResponseStatus) =>
  status === EvaluationResponseStatus.completed ||
  status === EvaluationResponseStatus.abandoned
